<template>
  <button :class="['base-button', themeClass]">{{ text }}</button>
</template>

<script>
import { computed, defineComponent } from 'vue'

export default defineComponent({
  props: {
    text: {
      type: String,
      default: ''
    },
    theme: {
      type: String,
      default: ''
    }
  },
  setup(props) {
    const themeClass = computed(() => props.theme && `base-button--${props.theme}`)

    return {
      themeClass
    }
  }

})
</script>

<style lang="scss" scoped>
.base-button {
    @include reset-button;
    justify-content: center;
    color: var(--color-white);
    background-color: var(--color-primary);
    padding: var(--measure-s);
    border-radius: 0.9rem;
    width: 100%;

    &:hover {
      filter: brightness(90%);
    }
}

.base-button--ghost {
  background-color: transparent;
  border: 1px solid var(--color-primary);
  color: var(--color-primary);

  &:hover {
      filter: brightness(45%);
  }
}

</style>
